// react
import { useState, Dispatch, SetStateAction, useEffect } from "react";
import { useTranslation } from "react-i18next";
// node-modules
// mui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  useTheme,
  DialogContentText,
  Typography,
  Box,
  LinearProgress,
  Select,
  MenuItem,
} from "@mui/material";
// src
import Icon from "./Icon";
import ChevronRight from "../../images/icons/neutral_edit/Chevron Right.svg";
import UploadARDataDialog from "./UploadARDataDialog";
import UploadZipDialog from "./UploadZipDialog";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { red } from "@mui/material/colors";

type Props = {
  projectID: string;
  projectName: string;
  setProjectName?: Dispatch<SetStateAction<string>>;
  isAR?: boolean;
  jobSiteId: string;
  setJobSiteId?: Dispatch<SetStateAction<string>>;
  setErrorSnackbar: Dispatch<SetStateAction<boolean>>;
  setErrorMsg: Dispatch<SetStateAction<string>>;
  setOpenWarning: Dispatch<SetStateAction<boolean>>;
  setMsgWarning: Dispatch<SetStateAction<string>>;
  setAnchorEl: Dispatch<SetStateAction<any>>;
  ar_color: string;
};

const UploadBaseDialog = (props: Props) => {
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = useState(false);
  const [progressDialog, setProgressDialog] = useState(false);
  // Loding flag
  const [uploadResult, setUploadResult] = useState(false);
  const [uploadingCheck, setUploadingCheck] = useState(false);
  const [uploadingPercent, setUpLoadingPercent] = useState(0);
  // const [selectType, setSelectType] = useState(props.isAR ? 0 : 1);
  const [selectType, setSelectType] = useState(1);
  const [isShortageImageDialog, setIsShortageImageDialog] =
    useState<boolean>(false);

  window.addEventListener("focus", function () {
    if (!openDialog) {
      document.body.style.cssText = "";
    }
  });

  useEffect(() => {
    // アップロード状態チェック
    if (uploadingPercent === 100) setUploadingCheck(true);
    else setUploadingCheck(false);
  }, [uploadingPercent]);

  const handleOpen = async () => {
    setOpenDialog(true);
    props.setAnchorEl(null);
  };

  const handleClose = () => {
    setOpenDialog(false);
    const scrollY = document.body.style.top;
    document.body.style.cssText = "";
    window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
  };

  const handleResultClose = () => {
    setUploadResult(false);
    window.location.reload();
  };

  const handleShortageImageClose = () => {
    setIsShortageImageDialog(false);
  };

  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const customBackgroundStyles = {
    background: theme.palette.base.modal,
  };

  const customDialogBackgroundColor = {
    color: theme.palette.base.dialogBackground,
  };

  const customMainColor = {
    background: theme.palette.primary.main,
    boxShadow: "none",
  };

  const RightIcon = () => {
    return (
      <div className="upload-img">
        <Icon imagePath={ChevronRight} color={customColor.color} />
      </div>
    );
  };

  return (
    <>
      <div className="upload-div1">
        <MenuItem
          onClick={() => handleOpen()}
          sx={{ width: "230px", padding: "5px", ...customColor }}
        >
          <p className="upload-p">{t("UPLOAD")}</p>
          <RightIcon />
        </MenuItem>
        {/* アップロードダイアログ */}
        <Dialog
          open={openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{ id: "upload-file18" }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: customDialogBackgroundColor.color,
              },
            },
          }}
        >
          <DialogTitle className="upload-file16" style={customBackgroundStyles}>
            {t("UPLOAD_AR_DATA")}
            <Button
              style={customColor}
              className="x-btn upload-file15"
              onClick={handleClose}
            >
              ×
            </Button>
            <div className="border-comm" />
            <div />
          </DialogTitle>

          <DialogContent
            style={{
              overflowX: "hidden",
              overflowY: "hidden",
              textAlign: "left",
              ...customBackgroundStyles,
            }}
          >
            <DialogContentText style={customColor} className="upload-file7">
              {t("DATA_TYPE")}
            </DialogContentText>
            <Select
              value={selectType}
              onChange={(e) => setSelectType(e.target.value as number)}
              style={{ margin: "15px 0", height: "40px" }}
              sx={{
                ".MuiOutlinedInput-notchedOutline": {
                  borderColor: theme.palette.base.border,
                  borderWidth: "2px",
                },
              }}
            >
              {/* {props.isAR && (
                <MenuItem value={0}>{t("SHOOTING_DATA_ZIP")}</MenuItem>
              )} */}
              <MenuItem value={1}>{t("DESIGN_DATA_IFC")}</MenuItem>
              {props.isAR && (
                <MenuItem value={2}>{t("POINT_DATA_LAS")}</MenuItem>
              )}
              <MenuItem value={3}>{t("HEATMAP_DATA")}</MenuItem>

              <MenuItem value={4}>{t("HEATMAP_DATA_GEOJSON")}</MenuItem>
            </Select>
            {openDialog && selectType == 0 && (
              <UploadZipDialog
                projectID={props.projectID}
                projectName={props.projectName}
                setProjectName={props.setProjectName}
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                jobSiteId={props.jobSiteId}
                setJobSiteId={props.setJobSiteId}
                setErrorSnackbar={props.setErrorSnackbar}
                setErrorMsg={props.setErrorMsg}
                setOpenWarning={props.setOpenWarning}
                setMsgWarning={props.setMsgWarning}
                setProgressDialog={setProgressDialog}
                setUploadResult={setUploadResult}
                setUpLoadingPercent={setUpLoadingPercent}
                setIsShortageImageDialog={setIsShortageImageDialog}
              />
            )}
            {openDialog &&
              (selectType == 1 ||
                selectType == 2 ||
                selectType === 3 ||
                selectType === 4) && (
                <UploadARDataDialog
                  projectID={props.projectID}
                  projectName={props.projectName}
                  setProjectName={props.setProjectName}
                  openDialog={openDialog}
                  setOpenDialog={setOpenDialog}
                  jobSiteId={props.jobSiteId}
                  setJobSiteId={props.setJobSiteId}
                  setErrorSnackbar={props.setErrorSnackbar}
                  setErrorMsg={props.setErrorMsg}
                  setOpenWarning={props.setOpenWarning}
                  setMsgWarning={props.setMsgWarning}
                  setProgressDialog={setProgressDialog}
                  setUploadResult={setUploadResult}
                  setUpLoadingPercent={setUpLoadingPercent}
                  selectType={selectType}
                  ar_color={props.ar_color}
                />
              )}
          </DialogContent>
        </Dialog>
        {/* アップロードプログレスダイアログ */}
        <Dialog
          open={progressDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            className: "upload-loding-page",
            style: { ...customBackgroundStyles },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: customDialogBackgroundColor.color,
              },
            },
          }}
        >
          {uploadingCheck ? (
            <div className="upload-loding-comm">
              <Typography
                style={customColor}
                variant="h5"
                className="upload-loding"
              >
                {t("WAIT_LITTLE")}
              </Typography>
              <Box
                width="30%"
                mr={1}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <LinearProgress sx={{ height: "10px" }} />
              </Box>
            </div>
          ) : (
            <div className="upload-loding-comm">
              <Typography
                style={customColor}
                variant="h5"
                className="upload-loding"
              >
                {t("UPLOADING")}
              </Typography>
              <Box
                width="30%"
                mr={1}
                sx={{
                  position: "absolute",
                  top: "55%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <LinearProgress
                  variant="determinate"
                  value={uploadingPercent}
                  sx={{ height: "10px" }}
                />
              </Box>
              <Typography
                variant="body2"
                color="textSecondary"
                className="upload-loding upload-loding1"
              >
                {`${uploadingPercent}%`}
              </Typography>
            </div>
          )}
        </Dialog>
        {/* アップロード完了ダイアログ */}
        <Dialog
          open={uploadResult}
          PaperProps={{
            className: "upload-finish-page",
            style: { ...customBackgroundStyles },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: customDialogBackgroundColor.color,
              },
            },
          }}
        >
          <DialogTitle style={customColor} className="upload-file21">
            {t("UPLOAD_COMPLETE")}
            <Button
              style={customColor}
              className="x-btn upload-btn"
              onClick={handleResultClose}
            >
              ×
            </Button>
            <div id="border-comm" />
          </DialogTitle>
          <DialogContentText style={customColor} id="upload-file20">
            {t("UPLOAD_COMPLETE_2")}
          </DialogContentText>
          <Button
            style={customMainColor}
            className="upload-file22"
            size="small"
            variant="contained"
            onClick={handleResultClose}
          >
            {"OK"}
          </Button>
        </Dialog>
        {/* 画像枚数不足のダイアログ */}
        <Dialog
          open={isShortageImageDialog}
          PaperProps={{
            className: "upload-finish-page",
            style: { ...customBackgroundStyles },
          }}
          slotProps={{
            backdrop: {
              sx: {
                backgroundColor: customDialogBackgroundColor.color,
              },
            },
          }}
        >
          <DialogTitle style={customColor} className="upload-file21">
            {t("UPLOAD_ERROR")}
            <Button
              style={customColor}
              className="x-btn upload-btn"
              onClick={handleShortageImageClose}
            >
              ×
            </Button>
            <div id="border-comm" />
          </DialogTitle>
          <div
            style={{
              margin: 0,
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WarningAmberIcon sx={{ color: red[500] }} />
            <DialogContentText style={customColor} id="upload-file20">
              {t("INSUFFICIENT_PHOTOS_NUMBER")}
            </DialogContentText>
          </div>
          <DialogContentText style={customColor} id="upload-file20">
            {t("TAKE_TEN_MORE_PICTURE")}
          </DialogContentText>
          <Button
            style={customMainColor}
            className="upload-file22"
            size="small"
            variant="contained"
            onClick={handleShortageImageClose}
          >
            {t("CONFIRMATION")}
          </Button>
        </Dialog>
      </div>
    </>
  );
};

export default UploadBaseDialog;
